import { useQuery, keepPreviousData } from '@tanstack/react-query';
import type { InvoiceDetailsFilterInput } from '@/integrations/faturamento/client';
import { fetchInvoiceDetails } from '@/services/invoiceDetails';
import { useAppSelector } from '@/store/hooks';

interface UseInvoiceDetailsParams {
  id: string;
  page?: number;
  page_size?: number;
}

/**
 * Detalhe da medição composto no front (faturamento + agreements + catálogo + mtr-manager). As
 * unidades do store rotulam o estabelecimento quando o agreements não conhece a coleta.
 */
export const useInvoiceDetails = (params: UseInvoiceDetailsParams | null) => {
  const establishments = useAppSelector((s) => s.establishmentAccess.establishments);
  const filter: InvoiceDetailsFilterInput | null = params
    ? { id: params.id, page: params.page, page_size: params.page_size }
    : null;

  return useQuery({
    queryKey: ['invoice-details', params],
    queryFn: () => fetchInvoiceDetails(filter!, { establishments }),
    enabled: !!params?.id,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60,
  });
};
